var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"how-to"},[_c('h1',{staticClass:"text-shadow-thin-white"},[_vm._v(_vm._s(_vm.$t("berlin.howToPlay")))]),_c('p',[_vm._v(_vm._s(_vm.$t("berlin.howP1")))]),_c('p',[_c('span',{staticClass:"highlight text-shadow-extra-thin-white"},[_vm._v(" "+_vm._s(_vm.$t("berlin.howP2"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }